import { Box, Button, Link, Stack, Typography } from "@mui/material"
import { If } from "lib/@components/switch"
import { Else } from "lib/@components/else"
import Iconify from "minimals-template/components/Iconify"
import { useCreateRuleSet } from "./use-create-rule-set"
import illustrationSrc from "./illustration_empty_rule_set.svg"

export function RuleSetsEmpty({ status, archivedCount, onViewArchived, onViewActive, canManageOptimiser }) {
    const handleCreate = useCreateRuleSet()
    // Archived filter with no archived items: offer a way back to Active rather than the "create your first" state
    const isArchivedView = status === "archived"
    const archivedNoun = archivedCount === 1 ? "item" : "items"

    return (
        <Stack data-cy="rule-sets-empty" alignItems="center" justifyContent="center" spacing={2} sx={{ py: 4 }}>
            <Box component="img" src={illustrationSrc} sx={{ width: 275, height: 200 }} />
            <Stack spacing={0.5} alignItems="center">
                <Typography variant="h6">
                    <If value={isArchivedView}>
                        No archived rule sets
                        <Else>No rule sets yet</Else>
                    </If>
                </Typography>
                <Typography variant="body2" color="text.secondary" sx={{ maxWidth: 420, textAlign: "center" }}>
                    <If value={isArchivedView}>
                        There are no archived rule sets.
                        <Else>
                            Use reusable rules to include, exclude, or adjust tasks and compare how different approaches
                            affect cost
                        </Else>
                    </If>
                </Typography>
            </Stack>
            <If value={isArchivedView}>
                <Button variant="outlined" startIcon={<Iconify icon="mdi:arrow-left" />} onClick={onViewActive}>
                    Back to Active
                </Button>
                <Else>
                    <If value={canManageOptimiser}>
                        <Button variant="contained" startIcon={<Iconify icon="mdi:plus" />} onClick={handleCreate}>
                            Create Rule Set
                        </Button>
                    </If>
                    <If value={archivedCount > 0}>
                        <Typography variant="body2" color="text.secondary">
                            You have {archivedCount} archived {archivedNoun}
                            {" - "}
                            <Link component="button" variant="body2" onClick={onViewArchived}>
                                view archived
                            </Link>
                        </Typography>
                    </If>
                </Else>
            </If>
        </Stack>
    )
}
